document.addEventListener("DOMContentLoaded", function () {
    const lang = document.documentElement.lang;

    if (lang === 'ar') {
      document.documentElement.setAttribute('dir', 'rtl');
      document.documentElement.classList.add('is-arabic');

      const style = document.createElement("style");
      style.textContent = `
        body {
          direction: rtl !important;
          text-align: right !important;
        }
        .site-header, .product-title, .site-footer {
          text-align: right !important;
        }
      `;
      document.head.appendChild(style);
    }
  });